import { DetailColumn, DetailSection, LwButton } from 'redesign';
import { useTranslation } from 'react-i18next';
import { routes } from 'ogp/Routes';
import { IconEdit } from 'assets/img';
import { useCompanyRelativePath } from 'ogp/hooks';
import { Box } from '@mui/material';
import { useTheme } from '@mui/styles';

export const SettingsDetailTheme = () => {
  const { t } = useTranslation('ogp-screen-specific');
  const generatePath = useCompanyRelativePath();
  const theme = useTheme();

  const columns: DetailColumn[] = [
    {
      items: [
        {
          title: t('settings-theme-primary.title'),
          value: theme.palette.primary.main,
          showColorShowcase: true,
        },
        {
          title: t('settings-theme-secondary.title'),
          value: theme.palette.secondary.main,
          showColorShowcase: true,
        },
        {
          title: t('settings-theme-primary_accent.title'),
          value: theme.palette.lwPrimaryAccentDark[100],
          showColorShowcase: true,
        },
        {
          title: t('settings-theme-secondary_accent.title'),
          value: theme.palette.lwSecondaryAccentDark[100],
          showColorShowcase: true,
        },
      ],
    },
  ];

  return (
    <Box mb={4} gap={2} display="flex" flexDirection="column">
      <Box mb={4} display="flex" gap={2}>
        <LwButton
          to={generatePath(routes.SettingsEditTheme)}
          startIcon={<IconEdit />}
          color="primary"
          iconColorMode="fill"
        >
          {t('settings-detail.edit-button')}
        </LwButton>
      </Box>
      <DetailSection columns={columns} />
    </Box>
  );
};
